export default function ContactFilter() {
  return (
    <div className="add-filter">
      <div className="filter-title  filter-title-mob">
        <h5>Filter Contats</h5>
        <button className="mob-nav-open">☰</button>
      </div>
      <div className="filter-body filter-body-mob custom-scroll-right pt-0">
        <div className="sticky pt-2">
          <h6>
            <strong> My Primary Contacts</strong>
          </h6>
          <p>showing 751 Contats</p>

          <h6>
            <strong>My Secondary Contacts</strong>
          </h6>
          <p>showing 851 Contats</p>

          <h6>
            <strong> All Contacts</strong>
          </h6>
          <p>showing 7851 Contats</p>

          <div className="unique-Applicants">
            <button className="btn btn-md btn-deep-orange">
              Unique Applicants <span className="badge badge-light">123</span>
            </button>
          </div>

          <h6>
            <strong> All Filter</strong>
          </h6>
          <button className="btn btn-sm btn-deep-orange"> Clear All</button>
        </div>

        <ul className="modify-filter-title">
          <li>
            <h6>
              <i className="fas fa-ellipsis-v more-dot fa-sm"></i> classNameification{" "}
            </h6>
          </li>
          <li className="chose">Enquiry for</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>
          <li className="chose">Lead source</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>
          <li>
            <h6>
              <i className="fas fa-ellipsis-v more-dot fa-sm"></i> Basic Information{" "}
            </h6>
          </li>

          <li className="chose">Name</li>
          <li>
            <input
              type="text"
              name=""
              placeholder="Name.."
              className="form-control"
            />
          </li>
          <li className="chose">Telephone</li>
          <li>
            <input
              type="text"
              name=""
              placeholder="Enter Phone No"
              className="form-control"
            />
          </li>
          <li className="chose">Email</li>
          <li>
            <input
              type="email"
              name="email"
              placeholder="Enter Email"
              className="form-control"
            />
          </li>
          <li className="chose">Date Of Birth</li>
          <li>
            <input
              type="Date"
              name="date"
              placeholder="DD/MM/YYYY"
              className="form-control"
            />
          </li>
          <li className="chose">Gender</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">Male</option>
              <option value="">Female</option>
              <option value="">Other</option>
            </select>
          </li>
          <li className="chose">Marital Status</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">unmarried</option>
              <option value="">Married</option>
              <option value="">Other</option>
            </select>
          </li>

          <li className="chose">City</li>
          <li>
            <input
              type="text"
              name=""
              placeholder="Enter City"
              className="form-control"
            />
          </li>
          <li className="chose">State</li>
          <li>
            <input
              type="text"
              name=""
              placeholder="Enter State.."
              className="form-control"
            />
          </li>

          <li className="chose">Country</li>
          <li>
            <select className="form-control">
              <option value="">List few countries</option>
              <option value="">India</option>
              <option value="">Nepal</option>
              <option value="">Australia</option>
              <option value="">Chile</option>
              <option value="">China</option>
              <option value="">Afghanistan</option>
              <option value="">Bangladesh </option>
            </select>
          </li>

          <li className="chose">How did you hear about us</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Visa Expiry Date</li>
          <li>
            <input
              type="Date"
              name="Vdate"
              placeholder="DD/MM/YYYY"
              className="form-control"
            />
          </li>

          <li>
            <h6>
              <i className="fas fa-ellipsis-v more-dot fa-sm"></i> Identification{" "}
            </h6>
          </li>
          <li>
            <strong>Educational history</strong>
          </li>

          <li className="chose">Educational status</li>
          <li>
            <select className="form-control">
              <option value="">+2 High school (running)</option>
              <option value="">+2 High school (Passed)</option>
              <option value="">PCL Nursing</option>
              <option value="">Bachelors</option>
              <option value="">Bachelor’s running</option>
              <option value="">Masters</option>
              <option value="">Master’s Running</option>
              <option value="">PhD</option>
              <option value="">Diploma</option>
              <option value="">P.G. Diploma</option>
              <option value="">Others</option>
              <option value="">No Education Background</option>
            </select>
          </li>

          <li className="chose">Month of completion</li>
          <li>
            <select className="form-control">
              <option  value="1">
                Janaury
              </option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </li>

          <li className="chose">Year of Completion</li>
          <li>
            <select className="form-control">
              <option value="2020">2020</option>
              <option value="2019">2019</option>
              <option value="2018">2018</option>
              <option value="2017">2017</option>
              <option value="2016">2016</option>
              <option value="2015">2015</option>
              <option value="2014">2014</option>
              <option value="2013">2013</option>
              <option value="2012">2012</option>
              <option value="2011">2011</option>
              <option value="2010">2010</option>
              <option value="2009">2009</option>
              <option value="2008">2008</option>
              <option value="2007">2007</option>
              <option value="2006">2006</option>
              <option value="2005">2005</option>
              <option value="2004">2004</option>
              <option value="2003">2003</option>
              <option value="2002">2002</option>
              <option value="2001">2001</option>
              <option value="2000">2000</option>
            </select>
          </li>

          <li className="chose">Academic Percentage</li>
          <li>
            <input type="text" className="form-control" placeholder="Percentage" />
          </li>

          <li className="chose">English Test Status</li>
          <li>
            <select className="form-control">
              <option value="">---</option>
              <option value=""></option>
              <option value=""></option>
            </select>
          </li>
          <li className="chose">English Test Score</li>
          <li>
            <input
              type="text"
              className="form-control"
              placeholder="Enter English test score"
            />
          </li>

          <li>
            <strong>Future education</strong>
          </li>

          <li className="chose">Category of study</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Interested Field of Study</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Interested level of study</li>
          <li>
            <select className="form-control">
              <option value="">English with Diploma</option>
              <option value="">Diploma</option>
              <option value="">EAP with bachelors</option>
              <option value="">Bachelors</option>
              <option value="">PG Diploma</option>
              <option value="">Master</option>
              <option value="">Masters in research</option>
              <option value="">PhD</option>
              <option value="">Work Visa</option>
              <option value="">PR</option>
              <option value="">Others</option>
            </select>
          </li>

          <li className="chose">Preferred Destination I</li>
          <li>
            <select className="form-control">
              <option value="">Australia</option>
              <option value="">New Zealand </option>
              <option value="">UK</option>
              <option value="">Ireland</option>
              <option value="">Canada</option>
              <option value="">France</option>
              <option value="">Spain</option>
              <option value="">Germany</option>
              <option value="">Italy</option>
              <option value="">USA</option>
              <option value="">Others</option>
            </select>
          </li>

          <li className="chose">Preferred Destination II</li>
          <li>
            <select className="form-control">
              <option value="">Australia</option>
              <option value="">New Zealand </option>
              <option value="">UK</option>
              <option value="">Ireland</option>
              <option value="">Canada</option>
              <option value="">France</option>
              <option value="">Spain</option>
              <option value="">Germany</option>
              <option value="">Italy</option>
              <option value="">USA</option>
              <option value="">Others</option>
            </select>
          </li>

          <li className="chose">Preferred intake</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>
          <li className="chose">Intake year</li>
          <li className="text-center">
            <input type="date" name="from" />
          </li>

          <li className="chose">Financial Source</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li>
            <h6>
              <i className="fas fa-ellipsis-v more-dot fa-sm"></i> Status{" "}
            </h6>
          </li>

          <li className="chose">Meeting Interface</li>
          <li>
            <select className="form-control">
              <option value="">---</option>
              <option value=""> Face 2Face </option>
              <option value=""> Virtual </option>
            </select>
          </li>

          <li className="chose">Meeting date</li>
          <li>
            {" "}
            <input
              type="Date"
              name="Mdate"
              placeholder="DD/MM/YYYY"
              className="form-control"
            />
          </li>

          <li className="chose">Profile</li>
          <li>
            {" "}
            <select className="form-control">
              <option value="">---</option>
              <option value=""> </option>
            </select>
          </li>

          <li className="chose">Qualify</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Reason did not qualify?</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Rating</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Primary contact owner</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Secondary Contact owner</li>
          <li>
            <select className="form-control">
              <option value="">--Select--</option>
              <option value="">lorem ipsum</option>
            </select>
          </li>

          <li className="chose">Branch</li>
          <li>
            <select className="form-control">
              <option value="">Delhi - India </option>
              <option value="">Sri Nagar - India </option>
              <option value="">Chandigarh - India </option>
              <option value="">kathmandu - Nepal </option>
              <option value="">Mahendranagar - Nepal </option>
              <option value="">Dang - Nepal </option>
              <option value="">Sydney - Australia </option>
              <option value="">Santiago - Chile </option>
            </select>
          </li>
        </ul>
      </div>
    </div>
  );
}
